'use strict';

const renderPositionTitle = (data = {}) => {
    const text = [];

    if (data.person?.positionTitle) {
        text.push(data.person.positionTitle);
    }

    if (data.includeCompanyName && data.person?.company) {
        text.push(data.person.company);
    }

    return text.join(', ');
};

export {
    renderPositionTitle
};